module.exports = __webpack_public_path__ + "static/media/m_eyeshape_upturned_grey.d55fdfda.png";